export const CONS = {
  TITLE: 'We cannot find who you\'re looking for',
  TEXT: 'Choose another method to help find the person.',
  PRESCRIPTION_LABEL: 'Use their prescription label',
  PERSONAL_INFO: 'Try personal info again',
  ADDRESS: 'Use their address',
  CANCEL: 'Cancel',
  HELP: 'Need help?',
  HELP_CENTER: 'Help center',
  MEMBER_ID_MODAL: {
    TITLE: 'Where can I find my member ID?',
    TRY: 'If your member ID is not accepted, try:',
    LOCATING: 'Locating a number marked ID or RxID',
    REMOVING: 'Removing the first three letters',
    ENTERING: 'Entering it without the last two digits'
  },
  CALL: 'Call us at: ',
  NO: '1-888-607-4287',
  TYY: 'TTY: ',
  NO2: '711'
};

export const CONNECT_ANOTHER_WAY = 'Connect another way?';
export const CONNECT_ANOTHER_WAY_PRESCRIPTION_LABEL = 'Use a prescription label';
export const CONNECT_ANOTHER_WAY_PERSONAL_INFO = 'Use personal info';
export const CONNECT_ANOTHER_WAY_ADDRESS = 'Use an address';

// Translation configuration for connect-another-way page
export const CONNECT_ANOTHER_WAY_TRANSLATION_CONFIG = [
  { key: 'CONS', value: CONS, message: JSON.stringify(CONS) },
  { key: 'CONNECT_ANOTHER_WAY', value: CONNECT_ANOTHER_WAY, message: CONNECT_ANOTHER_WAY },
  {
    key: 'CONNECT_ANOTHER_WAY_PRESCRIPTION_LABEL',
    value: CONNECT_ANOTHER_WAY_PRESCRIPTION_LABEL,
    message: CONNECT_ANOTHER_WAY_PRESCRIPTION_LABEL
  },
  {
    key: 'CONNECT_ANOTHER_WAY_PERSONAL_INFO',
    value: CONNECT_ANOTHER_WAY_PERSONAL_INFO,
    message: CONNECT_ANOTHER_WAY_PERSONAL_INFO
  },
  {
    key: 'CONNECT_ANOTHER_WAY_ADDRESS',
    value: CONNECT_ANOTHER_WAY_ADDRESS,
    message: CONNECT_ANOTHER_WAY_ADDRESS
  }
];

// Helper function to process translated items
export const processConnectAnotherWayTranslations = (translatedItems: any) => {
  if (!translatedItems || Object.keys(translatedItems).length === 0) {
    translatedItems = {};
  }

  // Parse the CONS object with fallback
  const parsedCons = translatedItems[JSON.stringify(CONS)];
  let consTranslated = CONS;

  if (parsedCons) {
    try {
      consTranslated = typeof parsedCons === 'string' ? JSON.parse(parsedCons) : parsedCons;
    } catch {
      consTranslated = CONS;
    }
  }

  const {
    [CONNECT_ANOTHER_WAY]: CONNECT_ANOTHER_WAY_TRANSLATED = CONNECT_ANOTHER_WAY,
    [CONNECT_ANOTHER_WAY_PRESCRIPTION_LABEL]: CONNECT_ANOTHER_WAY_PRESCRIPTION_LABEL_TRANSLATED = CONNECT_ANOTHER_WAY_PRESCRIPTION_LABEL,
    [CONNECT_ANOTHER_WAY_PERSONAL_INFO]: CONNECT_ANOTHER_WAY_PERSONAL_INFO_TRANSLATED = CONNECT_ANOTHER_WAY_PERSONAL_INFO,
    [CONNECT_ANOTHER_WAY_ADDRESS]: CONNECT_ANOTHER_WAY_ADDRESS_TRANSLATED = CONNECT_ANOTHER_WAY_ADDRESS
  } = translatedItems;

  return {
    CONS: consTranslated,
    CONNECT_ANOTHER_WAY: CONNECT_ANOTHER_WAY_TRANSLATED,
    CONNECT_ANOTHER_WAY_PRESCRIPTION_LABEL: CONNECT_ANOTHER_WAY_PRESCRIPTION_LABEL_TRANSLATED,
    CONNECT_ANOTHER_WAY_PERSONAL_INFO: CONNECT_ANOTHER_WAY_PERSONAL_INFO_TRANSLATED,
    CONNECT_ANOTHER_WAY_ADDRESS: CONNECT_ANOTHER_WAY_ADDRESS_TRANSLATED
  };
};
